/**
 * @ngdoc directive
 * @name kareo.ui.shared.assets:relativeTime
 * @restrict E
 * @scope
 * @description
 * Relative Time takes a timestamp and turns it into a human readable date.
 *
 * <h1>Sample Output:</h1><br />
 * <b>Past Dated:</b><br />
 * Just now<br />
 * 9 minutes ago<br />
 * 17 hours ago<br />
 * Yesterday at 10:55am<br />
 * Thursday at 4:00pm<br />
 * December 8, 1999 at 4:00pm<br />
 *
 * <b>Future Dated:</b><br />
 * In 33 minutes<br />
 * In 7 hours<br />
 * Tomorrow<br />
 * Friday at 4:00pm<br />
 * January 8, 2018 at 4:00pm<br />
 *
 * @param {Date} time Date source of future or past timestamp.
 * @param {String | Optional} format Format of output either 'short' or 'long'. Default 'short'
 * @example
 <example module="kareo.ui.shared.directives.relative-time">
 <file name="index.html">
 <div ng-controller="RelativeTimeDemoCtrl" class="kareo" >
   <relative-time time="Date.now()" format="short"></relative-time><br />
   <relative-time time="getDate(30)" format="short"></relative-time><br />
   <relative-time time="getDate(999)" format="short"></relative-time><br />
 </div>
 </file>
 <file name="demo.js">
 var app = angular.module('kareo.ui.shared.directives.relative-time');

 app.controller('RelativeTimeDemoCtrl', ['$scope', function($scope){
       $scope.getDate = function(minutes){
         return moment().add('minutes', minutes).valueOf()
       };
     }]);
 </file>
 </example>
 */
angular.module('kareo.ui.shared.directives.relative-time', [])
  .directive('relativeTime', [
    function () {
      return {
        template: '{{ formattedTime }}', restrict: 'E', scope: {
          time: '=', format: '=?' // 'long' or 'short', default 'short'
        }, controller: [
          '$scope', function ($scope) {
            var LONG_DATE_FORMAT_STRING = 'MMMM D, YYYY [at] h:mma';

            function updateTime(time) {
              var momentTime;
              if (typeof (time) === 'number') {
                momentTime = moment(time);
              } else {
                momentTime = moment();
              }
              $scope.format = $scope.format || 'short';
              if ($scope.format === 'long') {
                $scope.formattedTime = momentTime.format(LONG_DATE_FORMAT_STRING);
              } else {
                var currentMoment = moment(new Date());
                var minutesSinceNow = currentMoment.diff(momentTime, 'minutes'), hoursSinceNow = currentMoment.diff(momentTime, 'hours'), daysSinceNow = currentMoment.diff(momentTime, 'days');
                if (minutesSinceNow < 0) {
                  // Future dated time stamps
                  if (minutesSinceNow === -1) {
                    $scope.formattedTime = 'In 1 minute';
                  } else if (minutesSinceNow > -60) {
                    $scope.formattedTime = 'In ' + Math.abs(minutesSinceNow) + ' minutes';
                  } else if (minutesSinceNow === -60) {
                    $scope.formattedTime = 'In 1 hour';
                  } else if (hoursSinceNow > -24) {
                    $scope.formattedTime = 'In ' + Math.abs(hoursSinceNow) + ' hours';
                  } else if (daysSinceNow === -1) {
                    $scope.formattedTime = 'Tomorrow';
                  } else if (daysSinceNow > -8) {
                    $scope.formattedTime = momentTime.format('dddd [at] h:mma');
                  } else {
                    $scope.formattedTime = momentTime.format(LONG_DATE_FORMAT_STRING);
                  }
                } else {
                  // Past time stamps
                  if (minutesSinceNow < 1) {
                    $scope.formattedTime = 'Just now';
                  } else if (minutesSinceNow === 1) {
                    $scope.formattedTime = '1 minute ago';
                  } else if (minutesSinceNow < 60) {
                    $scope.formattedTime = minutesSinceNow + ' minutes ago';
                  } else if (minutesSinceNow === 60) {
                    $scope.formattedTime = '1 hour ago';
                  } else if (hoursSinceNow < 24) {
                    $scope.formattedTime = hoursSinceNow + ' hours ago';
                  } else if (daysSinceNow === 1) {
                    $scope.formattedTime = 'Yesterday at ' + momentTime.format('h:mma');
                  } else if (daysSinceNow < 8) {
                    $scope.formattedTime = momentTime.format('ddd [at] h:mma');
                  } else {
                    $scope.formattedTime = momentTime.format('MMM D, YYYY [at] h:mma');
                  }
                }
              }
            }

            $scope.$watch('time', updateTime);
          }]
      };
    }]);
